import {
    addDoc,
    doc,
    updateDoc,
    collection,
    deleteDoc,
    getDoc,
} from "firebase/firestore";
import { db } from "../firebase";

export const createOrder = async (data: Partial<Order>) => {
    try {
        const res = await addDoc(collection(db, "orders"), data);
        return res;
    } catch (e) {
        return e;
    }
};

export const updateOrder = async (data: Partial<Order>) => {
    const orderRef = doc(db, "orders", `${data.id}`);
    try {
        const res = updateDoc(orderRef, data);
        return res;
    } catch (e) {
        return e;
    }
};

export const deleteOrder = async (orderId: string) => {
    const orderRef = doc(db, "orders", `${orderId}`);
    try {
        const res = await deleteDoc(orderRef);
        return res;
    } catch (e) {
        return e;
    }
};

export const getOrder = async (orderId: string) => {
    const orderRef = doc(db, "orders", `${orderId}`);
    try {
        const orderSnap = await getDoc(orderRef);
        if (orderSnap.exists()) {
            return orderSnap.data();
        } else {
            throw new Error("Zamówienie nie istnieje");
        }
    } catch (e) {
        return e;
    }
};
